<template>
  <div class="newsInformation">
    <detailsTop :topIndex="topIndex" />
    <div class="news-content">
      <div class="new-center">
        <bannerTips
          :bannerTipsList="bannerTipsList"
          :bannerIndex="2"
          @changeTips="changeTips"
        />

        <div class="new-article">
          <div class="info-title">
            <div class="info-left"></div>
            <div class="info-right">员工风采</div>
          </div>
          <div class="info-line"></div>
          <!-- <div
            v-html="userInfo.introductionContent"
            class="operate-content"
            ref="operateSizeRef"
            id="operate-content"
          ></div> -->
        </div>
      </div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import bannerTips from "@/components/bannerTips";
import { getTAboutUsInfo ,selectTNewsPage} from "@/api/api.js";

export default {
  name: "news",
  components: {
    detailsTop,
    pageBottom,
    bannerTips,
  },
  data() {
    return {
      bannerTipsList: [],
      topIndex: 6,
      bannerIndex: 2,
      userInfo: "",
    };
  },
  created() {
    this.bannerTipsList = JSON.parse(localStorage.getItem("bannerList"));

    this.$route.query.bannerIndex
      ? (this.bannerIndex = this.$route.query.bannerIndex)
      : (this.bannerIndex = 0);
    this.$route.query.topIndex
      ? (this.topIndex = this.$route.query.topIndex)
      : (this.topIndex = 6);
    this.getTAboutUsInfo();
    this.getData()
  },
  methods: {
    async getTAboutUsInfo() {
      const { data } = await getTAboutUsInfo();
      this.userInfo = data.data;
    },

    async getData() {
      var params = {
        page: this.page,
        size: this.size,
        projectTypeParentId: this.bannerTipsList[this.bannerIndex]?.parentId,
        projectTypeSubId: this.bannerTipsList[this.bannerIndex]?.projectTypeId,
      };
      const { data } = await selectTNewsPage(params);
      if (data.code === 200) {
      //可以获取数据，但是数据的内容content为null

        // this.newList = data.data.list;
        // this.total = data.data.total;
      }
    },



    changeTips(index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: "contactUS",
            query: { bannerIndex: index },
          });
          break;

        case 1:
          this.$router.push({
            name: "aftersales",
            query: { bannerIndex: index },
          });

          break;
        case 2:
          this.$router.push({ name: "support", query: { bannerIndex: index } });

          break;
        case 3:
          this.$router.push({ name: "join", query: { bannerIndex: index } });
          break;
        case 4:
          this.$router.push({ name: "message", query: { bannerIndex: index } });
          break;
      }
      localStorage.setItem("bannerList", JSON.stringify(this.bannerTipsList));
    },

  },
};
</script>

<style scoped lang="less">
.news-content {
  width: 86%;
  max-width: 1440px;
  margin: 20px auto;
  height: 100%;




  .new-center {
    // flex: 5.3;
    background: #f4f4f4;
    .new-article {
      margin: 22px 0;
      background: #ffffff;
      width: 100%;
      min-height: 200px;

      .info-title {
        display: flex;
        align-items: center;
        padding-top: 25px;
        padding-left: 26px;

        .info-left {
          width: 5px;
          height: 28px;
          background: #46739f;
        }

        .info-right {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          margin-left: 16px;
        }
      }
      .info-line {
        width: 96%;
        margin: 0 auto;
        height: 1px;
        background: #eeeeee;
        margin-top: 25px;
      }
    }
  }


  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #fff;
  }
}

.title {
  width: 100%;
  height: 40px;
  margin: 10px 0;
  font-size: 20px;
  color: #333333;
  line-height: 40px;
}

.imgWrap {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  .imgitem {
    width: 32%;

    img {
      width: 260px;
      height: 260px;
    }
  }
}

@media only screen and (max-width: 1550px) {
  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }
}
.operate-content {
  width: 100%;
  margin: 0 auto;
  padding: 5px 40px;
  box-sizing: border-box;
  color: #515151;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
}
</style>
